<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import HumanAttentionToast from './HumanAttentionToast.vue';
import HumanAttentionActiveBadge from './HumanAttentionActiveBadge.vue';

const toasts = useMapGetter('painelHumanAttention/getToasts');
const stack = computed(() => toasts.value || []);
</script>

<template>
  <Teleport to="body">
    <div
      class="fixed top-6 right-6 z-[60] flex flex-col gap-3 pointer-events-none"
    >
      <div
        v-for="toast in stack"
        :key="toast.toastId"
        class="pointer-events-auto relative"
      >
        <HumanAttentionToast
          :toast-id="toast.toastId"
          :request="toast.request"
        />
      </div>
    </div>
  </Teleport>
  <HumanAttentionActiveBadge />
</template>
